import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../TextField';
import utils from 'helpers/utils';

const DateTextField = (props) => {
    const {
        label,
        options,
        value,
    } = props;

    if (utils.isEmpty(value)) {
        return null;
    }

    return <TextField
        label={ label }
        value={ utils.toDateString(
            utils.createDateTime(value), options
        ) }
    />;
};

DateTextField.defaultProps = {
    options: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    },
};

DateTextField.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

export default DateTextField;



// WEBPACK FOOTER //
// ./src/components/show/DateFields/DateTextField.js